import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { RateReview, HourglassEmpty, CheckCircle } from "@mui/icons-material";
import { useGetReviewerStatsQuery } from "../../../../app/questionApiSlice";

const ReviewerOverview = () => {
  const navigate = useNavigate();
  const { data: stats } = useGetReviewerStatsQuery();

  const cards = [
    {
      label: "Questions Reviewed",
      count: stats?.reviewed_count ?? 0,
      icon: <RateReview sx={{ fontSize: 28, color: "text.secondary" }} />,
    },
    {
      label: "Pending Review",
      count: stats?.pending_count ?? 0,
      icon: <HourglassEmpty sx={{ fontSize: 28, color: "text.secondary" }} />,
      link: "/lms/reviews",
    },
    {
      label: "Approved Questions",
      count: stats?.approved_count ?? 0,
      icon: <CheckCircle sx={{ fontSize: 28, color: "text.secondary" }} />
    },
  ];

  return (
    <Box>
      <Typography
        variant="h3"
        sx={{
          fontSize: { xs: "1rem", md: "1.25rem" },
          fontWeight: 700,
          letterSpacing: "-1px",
          mb: 3,
        }}
      >
        Reviewer Overview
      </Typography>

      <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "auto",
              sm: "auto",
              md: "auto auto auto",
              lg: "auto auto auto",
            },
            gap: { xs: 2.5, sm: 2, md: 2, lg: 2.5 },
          }}
        >
          {cards.map((card) => (
            <Box
              key={card.label}
              onClick={() => card.link && navigate(card.link)}
              sx={{
                borderRadius: "6px",
                backgroundColor: (theme) => theme.palette.mode === "dark" ? "#1e1e1e" : "#fff",
                padding: "2em 1.5em",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                width: "100%",
                minWidth: "18.2em",
                cursor: card.link ? "pointer" : "default",
                transition: "box-shadow 0.3s ease, transform 0.3s ease",
                "&:hover": card.link
                  ? {
                      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                      transform: "translateY(-2px)",
                    }
                  : {},
              }}
            >
              <Box
                sx={{
                  padding: ".5em .7em",
                  backgroundColor: (theme) => theme.palette.mode === "dark" ? "#2a2a2a" : "#F4F6FAB2",
                  borderRadius: "10px",
                  marginBottom: ".5em",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {card.icon}
              </Box>
              <Typography
                variant="body2"
                sx={{ fontSize: { xs: ".9rem", md: "1rem" }, fontWeight: 500 }}
              >
                {card.label} ({card.count})
              </Typography>
            </Box>
          ))}
      </Box>
    </Box>
  );
};

export default ReviewerOverview;
